import { ApplicationsAPI } from "api/api/applicationsApi/applicationsApi";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  GetApplicationsByIdParams,
  GetApplicationsByIdResponse,
} from "api/api/applicationsApi/types";

export const getApplicationsById = createAsyncThunk<
  GetApplicationsByIdResponse,
  GetApplicationsByIdParams
>("applications/getApplicationsById", async (params, { rejectWithValue }) => {
  try {
    const data = await ApplicationsAPI.getApplicationsById(params);
    return data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error(
        "Error while getting applications by ID",
        error.response?.data
      );
      return rejectWithValue(error.response?.data || "Unknown error");
    } else {
      console.error("Error while getting applications by ID", error);
      return rejectWithValue(
        "Что-то пошло не так... Попробуйте обновить страницу"
      );
    }
  }
});
